import React, { useState,
  useContext}               from 'react';
import { useTranslation }   from 'react-i18next';
import PropTypes            from 'prop-types';
import clsx                 from 'clsx';
import { withRouter }       from 'react-router-dom';
import Card                 from '@material-ui/core/Card';
import Grid                 from '@material-ui/core/Grid';
import CardContent          from '@material-ui/core/CardContent';
import DrawerContext        from '~/contexts/Drawer';
import Button               from '~/components/Button';
import useStyles            from './styles';
import InputCheckBox        from '~/components/Checkbox';

function Form(props){
  const classes = useStyles();
  const { t } = useTranslation();
  const { onSubmit, cancelRoute, children, isPersisted, submitText, cancelText, history, showFooter = true, showCancel = true, isStreamActive = false } = props;
  const [saveAndContinue, setSaveAndContinue ] = useState(false);
  const [loading, setLoading] = useState(false);
  const { open } = useContext(DrawerContext);

  function submit(){
    setLoading(true);
    const resolve = () => {
      // toast.success(t('form-toast-success'));
      setLoading(false);
    };
    const reject = () => setLoading(false);
    onSubmit(saveAndContinue)
      .then(resolve)
      .catch(reject);
  }

  function handleCancelRoute(){
    if (cancelRoute)
      history.push(cancelRoute);

    history.goBack();
  }

  return (
    <div>
      {children}

      { showFooter && <footer className={clsx('no-printable', classes.footerDrawerClosed, open && classes.footerDrawerOpen)}>
        <Card>
          <CardContent className={classes.footer}>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-end"
            >
              { !isPersisted && <InputCheckBox
                className={classes.checkBox}
                color='success'
                checked={saveAndContinue}
                onChange={()=> setSaveAndContinue(!saveAndContinue)}
                label={t('form-saveAndContinue')}
              />}

              { showCancel && <Button
                onClick={handleCancelRoute}
                className={classes.button}
                color="grey"
                disabled={isStreamActive}
                >
                {cancelText ? cancelText : t('form-cancel')}
              </Button> }

              <Button
                disabled={loading}
                onClick={() => submit()}
                className={classes.button}
                color="success"
                >
                {submitText ? submitText : t('form-submit')}
              </Button>
            </Grid>
          </CardContent>
        </Card>
      </footer> }
  </div>
  );
}

Form.propTypes={
  //PROPTYPES para PROMISES
  onSubmit: PropTypes.func.isRequired,
  cancelRoute: PropTypes.string,
  isPersisted: PropTypes.bool,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  isStreamActive: PropTypes.bool,
  showCancel: PropTypes.bool,
};

Form.defaultProps={
  isPersisted: false,
  isStreamActive: false,
};

export default withRouter(Form);
